import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Vendor
import { NovoElementProviders, NovoElementsModule } from 'novo-elements';
import { ChomskyModule } from 'chomsky-ng2';

import { AppComponent } from './app.component';
import { ConsentService } from './consent';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // Vendor
    NovoElementsModule,
    NovoElementProviders.forRoot(),
    ChomskyModule,
  ],
  providers: [
    ConsentService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/app/app.module.ts